export default "/images/vendor/geoportal-extensions-openlayers/src/OpenLayers/CSS/Controls/Drawing/drawing-save.svg?824254438c1f64b92be9f766842af6e8";